export default __webpack_public_path__ + "static/media/euro-circled-blue.5ddf0ae9.svg";